import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Paper, Typography } from '@mui/material'

export const InstructionOptions = () => {
  const { t } = useTranslation()
  return (
    <Paper>
      <Box padding={2}>
        <Box component="dl" display={'flex'} paddingY={2} margin={0}>
          <Box component="dt">
            <Typography
              color={'#000'}
              fontSize={'14px'}
              fontFamily={'Roboto'}
              fontWeight={'Regular'}
              lineHeight={'14px'}
              letterSpacing={'0em'}
              textAlign={'left'}
              width={'131px'}
            >
              Plan
            </Typography>
          </Box>
          <Box component="dd">
            <Typography
              color={'#000'}
              fontSize={'14px'}
              fontFamily={'Roboto'}
              fontWeight={'bold'}
              lineHeight={'14px'}
              letterSpacing={'0em'}
              textAlign={'left'}
              minWidth={'131px'}
            >
              BASIC
            </Typography>
          </Box>
        </Box>
        <Box component="dl" display={'flex'} paddingY={2} margin={0}>
          <Box component="dt">
            <Typography
              color={'#000'}
              fontSize={'14px'}
              fontFamily={'Roboto'}
              fontWeight={'Regular'}
              lineHeight={'14px'}
              letterSpacing={'0em'}
              textAlign={'left'}
              width={'131px'}
            >
              Wrapping
            </Typography>
          </Box>
          <Box component="dd">
            <Typography
              color={'#000'}
              fontSize={'14px'}
              fontFamily={'Roboto'}
              fontWeight={'bold'}
              lineHeight={'14px'}
              letterSpacing={'0em'}
              textAlign={'left'}
              minWidth={'131px'}
            >
              Yes
            </Typography>
          </Box>
        </Box>
        <Box component="dl" display={'flex'} paddingY={2} margin={0}>
          <Box component="dt">
            <Typography
              color={'#000'}
              fontSize={'14px'}
              fontFamily={'Roboto'}
              fontWeight={'Regular'}
              lineHeight={'14px'}
              letterSpacing={'0em'}
              textAlign={'left'}
              width={'131px'}
            >
              Options
            </Typography>
          </Box>
          <Box component="dd">
            <Typography
              color={'#000'}
              fontSize={'14px'}
              fontFamily={'Roboto'}
              fontWeight={'bold'}
              lineHeight={'14px'}
              letterSpacing={'0em'}
              textAlign={'left'}
              minWidth={'131px'}
            >
              Engine Drop Down
            </Typography>
          </Box>
        </Box>
      </Box>
    </Paper>
  )
}
